// extracted by mini-css-extract-plugin
module.exports = {"about":"_71c5a2","about__container":"_0e7a2a","about__header":"_97ac7b","about__content":"_549cc8","about__block-header":"_333203"};